/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Consent_RequiredInputs */



/**
* | output |
* | --- |
* | "Please tick the box to subscribe" |
*
* @param {Newsletter_Consent_RequiredInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const newsletter_consent_required = /** @type {((inputs?: Newsletter_Consent_RequiredInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Consent_RequiredInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("请勾选此项以订阅")
	return /** @type {LocalizedString} */ ("Please tick the box to subscribe")
});